export const SUPER_CATEGORY_LIST_REQUESTING =
	'kyc/SUPER_CATEGORY_LIST_REQUESTING';
export const SUPER_CATEGORY_LIST_SUCCESS = 'kyc/SUPER_CATEGORY_LIST_SUCCESS';
export const SUPER_CATEGORY_LIST_ERROR = 'kyc/SUPER_CATEGORY_LIST_ERROR';
export const CATEGORY_LIST_REQUESTING = 'kyc/CATEGORY_LIST_REQUESTING';
export const CATEGORY_LIST_SUCCESS = 'kyc/CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_ERROR = 'kyc/CATEGORY_LIST_ERROR';
export const SUB_CATEGORY_LIST_REQUESTING = 'kyc/SUB_CATEGORY_LIST_REQUESTING';
export const SUB_CATEGORY_LIST_SUCCESS = 'kyc/SUB_CATEGORY_LIST_SUCCESS';
export const SUB_CATEGORY_LIST_ERROR = 'kyc/SUB_CATEGORY_LIST_ERROR';

export const PINCODE_DETAILS_REQUESTING = 'kyc/PINCODE_DETAILS_REQUESTING';
export const PINCODE_DETAILS_SUCCESS = 'kyc/PINCODE_DETAILS_SUCCESS';
export const PINCODE_DETAILS_ERROR = 'kyc/PINCODE_DETAILS_ERROR';
export const UPDATE_MERCHANT_DETAILS = 'kyc/UPDATE_MERCHANT_DETAILS';
export const UPDATE_MERCHANT_DETAILS_SUCCESS =
	'kyc/UPDATE_MERCHANT_DETAILS_SUCCESS';
export const UPDATE_MERCHANT_DETAILS_ERROR =
	'kyc/UPDATE_MERCHANT_DETAILS_ERROR';
export const KYC_INIT_REQUESTED = 'kyc/KYC_INIT_REQUESTED';
export const KYC_INIT_SUCCESS = 'kyc/KYC_INIT_SUCCESS';
export const KYC_INIT_ERROR = 'kyc/KYC_INIT_ERROR';
export const KYC_STATUS_REQUESTED = 'kyc/KYC_STATUS_REQUESTED';
export const KYC_STATUS_SUCCESS = 'kyc/KYC_STATUS_SUCCESS';
export const KYC_STATUS_ERROR = 'kyc/KYC_STATUS_ERROR';
export const RESET_KYC_PAGE_DATA = 'kyc/RESET_KYC_PAGE_DATA';
